export default function SchemaMarkup() {
  const localBusiness = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "NG Industries",
    "description": "Australian manufacturer of industrial textile solutions including PVC warehouse dividing walls, industrial sliding curtains, heavy-duty covers, and weather protection systems.",
    "url": "https://ngindustries.com.au",
    "telephone": "+61413136160",
    "email": "office@ngindustries.com.au",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "8 Blamey Place",
      "addressLocality": "O'Connor",
      "addressRegion": "WA",
      "postalCode": "6163",
      "addressCountry": "AU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -32.06,
      "longitude": 115.79
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "07:00",
        "closes": "16:30"
      }
    ],
    "areaServed": {
      "@type": "Country",
      "name": "Australia"
    },
    "priceRange": "$$",
    "image": "https://ngindustries.com.au/logo-white-hires.png",
    "sameAs": []
  };

  const products = [
    { name: "PVC Warehouse Dividing Walls", desc: "Heavy-duty PVC partition walls for warehouse space division, temperature control, and dust containment." },
    { name: "Industrial Sliding Curtains", desc: "Robust sliding curtain systems for flexible access and environmental separation in industrial facilities." },
    { name: "Industrial Covers", desc: "Custom-manufactured protective covers for machinery, equipment, and materials." },
    { name: "Welding Screens", desc: "UV-protective welding safety screens for worker protection from radiation, sparks, and spatter." },
    { name: "Weather Protection Systems", desc: "Comprehensive weather protection for open-sided buildings, loading areas, and outdoor workspaces." },
    { name: "Custom Textile Solutions", desc: "Bespoke industrial textile products designed and manufactured to unique specifications." },
  ];

  const productSchema = products.map((p) => ({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": p.name,
    "description": p.desc,
    "brand": { "@type": "Brand", "name": "NG Industries" },
    "manufacturer": { "@type": "Organization", "name": "NG Industries" },
    "countryOfOrigin": { "@type": "Country", "name": "Australia" },
    "url": "https://ngindustries.com.au/products",
  }));

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      { "@type": "Question", "name": "What materials do you use for your PVC products?", "acceptedAnswer": { "@type": "Answer", "text": "We use commercial-grade, heavy-duty PVC materials sourced from leading Australian and international suppliers. Our PVC is UV-stabilized, flame-retardant, and designed to withstand harsh industrial environments." }},
      { "@type": "Question", "name": "How long does installation typically take?", "acceptedAnswer": { "@type": "Answer", "text": "Installation timeframes vary by project size. Small to medium installations are typically completed within 1-3 days. Large-scale projects may take 5-10 business days." }},
      { "@type": "Question", "name": "Do you offer custom sizes and configurations?", "acceptedAnswer": { "@type": "Answer", "text": "Absolutely. Every product we manufacture is custom-built to your exact specifications. We conduct on-site measurements and consultations to ensure a perfect fit for your facility." }},
      { "@type": "Question", "name": "Are your products compliant with Australian safety standards?", "acceptedAnswer": { "@type": "Answer", "text": "Yes, all our products comply with relevant Australian Standards including fire resistance, UV protection, and workplace safety requirements." }},
      { "@type": "Question", "name": "What warranty do you offer?", "acceptedAnswer": { "@type": "Answer", "text": "We offer a 12 month workmanship warranty on all our products. Material warranties are limited to those offered by the original manufacturer." }},
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusiness) }} />
      {productSchema.map((p, i) => (
        <script key={`product-${i}`} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(p) }} />
      ))}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}
